var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClockYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0C12.0897 0 0 12.0897 0 27C0 41.9103 12.0897 54 27 54C41.9103 54 54 41.9103 54 27C54 12.0897 41.9103 0 27 0ZM37.6373 35.2989L35.9136 37.6493C35.8761 37.7005 35.8289 37.7438 35.7746 37.7766C35.7204 37.8095 35.6601 37.8313 35.5974 37.8409C35.5347 37.8504 35.4707 37.8474 35.4091 37.8321C35.3475 37.8168 35.2896 37.7895 35.2386 37.7518L25.2703 30.4835C25.2082 30.4389 25.1577 30.38 25.1231 30.3119C25.0885 30.2437 25.0708 30.1682 25.0714 30.0917V13.5C25.0714 13.2348 25.2884 13.0179 25.5536 13.0179H28.4525C28.7176 13.0179 28.9346 13.2348 28.9346 13.5V28.4163L37.5288 34.6299C37.7458 34.7806 37.794 35.0819 37.6373 35.2989Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockYellow);
export default __webpack_public_path__ + "static/media/icon-clock-yellow.70550b5a.svg";
export { ForwardRef as ReactComponent };